import { Link } from 'react-router-dom'

import './AuthScreenWrapper.css'

function AuthScreenWrapper({children, heading, linkOne, textOne, helperTextTwo, textTwo, linkTwo}) {
  return (
    <section className="auth_page page_padding">
        <div className="container">
            <div className="centered_form_wrapper">
                <div className="form_wrapper">
                    <h3>{heading}</h3>
                    {children}
                    <Link to={linkOne} className='btn_text forgot_pass'>{textOne}</Link>
                    <div className="dha_box">
                        <p className="body_text">{helperTextTwo}</p>
                        <Link to={linkTwo} className='btn_text sign_up'>{textTwo}</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default AuthScreenWrapper